__turbopack_context__.v({
  "input": "MantineTheme-module__QbhQkq__input",
  "rainbowGlow": "MantineTheme-module__QbhQkq__rainbowGlow",
  "root": "MantineTheme-module__QbhQkq__root",
});
